import createVueComponent from '../createVueComponent';

const SignalZero = createVueComponent('SignalZeroIcon', [
  ['path', { d: 'M2 20h.01', key: '4haj6o' }],
]);

export default SignalZero;
